import api from '../../services/api';
import moment from 'moment';
import * as type from '../types';

export default {
    namespaced: true,
    state: {
        headers: [
            {
                text: 'Brand',
                value: 'brandName',
                sortable: true,
                // width: '150'
            },
            {
                text: 'Segment',
                value: 'segment',
                sortable: true,
                // width: '150'
            },
            {
                text: 'PO #',
                value: 'purchaseOrderNumber',
                sortable: true,
                // width: '150'
            },
            {
                text: 'Invoice #',
                value: 'invoiceNumber',
                sortable: true,
                // width: '150'
            },
            {
                text: 'Invoice Date',
                value: 'invoiceDate',
                sortable: true,
                // width: '150'
            },
            {
                text: 'Net Terms',
                value: 'invoiceTerms',
                sortable: true,
                // width: '150'
            },
        ],
        records: [],
        loading: false,
        authenticated: false
    },
    getters: {
        authenticated: state => state.authenticated,
        getHeaders: state => state.headers,
        getRecords: state => state.records
    },
    mutations: {
        [type.GET_INVOICE_RECORDS]: (state, payload) => state.records = payload,
        //[type.Extensiv_SET_AUTH]: state => state.authenticated = true,
        //[type.Extensiv_REMOVE_AUTH]: state => state.authenticated = false,
    },
    actions: {
       
    }
}